module.exports = __webpack_public_path__ + "img/people-8-min.351ef66f.png";